import type { Psbt } from 'bitcoinjs-lib';

import { InvalidPsbtError } from '../../../errors/InvalidPsbtError';
import { extractAddressFromInput } from '../extractAddressFromInput';

type ValidateSigningAddressParams = {
  index: number;
  inputAtIndex: Psbt['data']['inputs'][0];
  psbt: Psbt;
  signingAddress: string;
};

export const validateSigningAddress = ({
  index,
  inputAtIndex,
  psbt,
  signingAddress,
}: ValidateSigningAddressParams) => {
  // we need to extract the address from the input at the current signing index
  // to be able to compare it to the address provided in the request for the current index
  const extractedAddress = extractAddressFromInput({
    index,
    input: inputAtIndex,
    psbt,
  });

  if (!extractedAddress) {
    throw new InvalidPsbtError(
      `Could not extract address from input at index ${index}`
    );
  }

  if (extractedAddress !== signingAddress) {
    throw new InvalidPsbtError(
      `Signing address does not match with address extracted from input at index ${index}`
    );
  }
};
